<template>
  <TabBar activeTabName="map" />
  <FleetMap />
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import CustomerMainList from '@/components/fleet/CustomerMainList.vue'
import SiteMainList from '@/components/fleet/SiteMainList.vue'
import FleetMap from '@/components/fleet/FleetMap/FleetMap.vue'
import NavigationService from '@/services/NavigationService'
import TabBar from '@/components/fleet/TabBar.vue'

@Options({
  components: {
    CustomerMainList,
    SiteMainList,
    FleetMap,
    TabBar
  }
})
export default class FleetHome extends Vue {
  mounted () {
    NavigationService.setNavLevel2('Fleet', 'Devices', '#/fleet', '')
  }
}
</script>
